import { render, staticRenderFns } from "./goodsgroup.vue?vue&type=template&id=4610af94&scoped=true&"
import script from "./goodsgroup.vue?vue&type=script&lang=js&"
export * from "./goodsgroup.vue?vue&type=script&lang=js&"
import style0 from "./goodsgroup.vue?vue&type=style&index=0&id=4610af94&prod&lang=css&"
import style1 from "./goodsgroup.vue?vue&type=style&index=1&id=4610af94&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610af94",
  null
  
)

export default component.exports